export const withD = async (App) => {
    if (typeof window !== 'undefined') {
        // This serializes the dynamic modules list, and then preloads them before React hydration occurs
        try {
            const serializedContainer = document.querySelector(
                '#__WEB_PLATFORM_DYNAMIC_MODULES'
            );
            if (serializedContainer) {
                const dynamics = JSON.parse(serializedContainer.innerHTML);
                if (
                    Array.isArray(dynamics) &&
                    dynamics.length > 0 &&
                    // eslint-disable-next-line no-underscore-dangle
                    typeof window.__NEXT_PRELOADREADY === 'function'
                ) {
                    /**
                     * dynamic npm modules AND MFE ID's that were SSR'd.
                     * These are fed into __NEXT_PRELOADREADY so loadable can map them to
                     * loader promises that need to be resolved before React hydrates.
                     */
                    const dynamicModulesAndSubApps = dynamics.map(
                        ({ module: dynamicModuleName }) =>
                            `${dynamicModuleName}`
                    );
                    if (dynamicModulesAndSubApps.length > 0) {
                        // eslint-disable-next-line no-underscore-dangle
                        await window.__NEXT_PRELOADREADY(
                            dynamicModulesAndSubApps
                        );
                    }
                }
            }
        } catch (e) {
            console.error('Error parsing dynamic modules', e);
            // Do nothing and let page keep hydrating. Worst case dynamic modules exhibit FOUC
        }
    }
    return App;
};
